import { z } from "zod";

export const CreatePTWSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  jsaId: z
    .object({ label: z.string(), value: z.string() })
    .nullable()
    .optional(),
  siteId: z
    .object({ label: z.string(), value: z.string() })
    .nullable()
    .optional(),
  location: z.string().optional(),
  permitType: z.string().optional(),
  validFrom: z
    .date({
      required_error: "Valid from date is required",
    })
    .optional(),
  validTo: z
    .date({
      required_error: "Valid to date is required",
    })
    .optional(),
});

export type TCreatePTW = z.infer<typeof CreatePTWSchema>;
